import './shared/ui/CustomAudioPlayerElement.js';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import './i18n'
import App from './App.jsx'
import { queryClient } from './app/queryClient.js'
import { installSavePulse } from './app/savePulse.js'
import { useAuthStore } from './shared/store/useAuthStore'

installSavePulse()
// frontend-restructuring Fase 3 (03.1-auth-store.md §1/§8) -- reemplaza `<UserProvider>`.
// Llamada directa, no un componente montado con `useEffect`: ese patrón puede doble-invocar
// bajo StrictMode en dev (la misma clase de bug que este mismo plan acaba de arreglar en
// DoctexHtml.jsx), y `bootstrap()` ya es idempotente por su propia cuenta de todos modos.
useAuthStore.getState().bootstrap()
import { CalendarProvider } from './features/calendar/CalendarContext'
import { ToastProvider } from './shared/ui/Toast/ToastProvider'
import { CommentDraftProvider } from './features/comments/context/CommentDraftContext'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <CalendarProvider>
          <CommentDraftProvider>
            <App />
          </CommentDraftProvider>
        </CalendarProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
